import React from "react";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Button } from "@pd/pd-ui-kit";
import { Controller, useForm } from "react-hook-form";

import Modal from "~/shared/ui/Fields/Modal";
import TextArea from "~/shared/ui/Fields/TextArea";
import {
  useURLParamsGetter,
  useURLParamsSetter,
} from "~/hooks/useURLParamsSetter";
import {
  defaultValue,
  REASONS_OPTIONS,
} from "~/pages/Ivideon/CameraList/options";
import { Select } from "~/shared/ui/Select";

import s from "./s.less";

interface RejectedModalIProps {
  handleAcceptCamera: (id: string, message: string) => void;
  nextKey: () => void;
}

const RejectedModal = ({
  handleAcceptCamera,
  nextKey,
}: RejectedModalIProps) => {
  const { openModalReject } = useURLParamsGetter<{ openModalReject: string }>();

  const setURLParams = useURLParamsSetter();

  const closeCheckCameraModal = () => {
    setURLParams({ openModalReject: "" });
    sessionStorage.removeItem("cameraId");
    nextKey();
  };

  const schema = yup.object({
    reasonList: yup
      .object({
        value: yup.string().required("Выберите причину"),
        label: yup.string(),
      })
      .required(),
    reason: yup.string().when("reasonList", {
      is: (reasonList: any) => reasonList?.value === "other",
      then: (schema) => schema.required("Напишите причину отклонения"),
      otherwise: (schema) => schema.optional(),
    }),
  });

  const {
    control,
    handleSubmit,
    watch,
    formState: { isValid },
  } = useForm({
    defaultValues: defaultValue,
    resolver: yupResolver(schema),
    mode: "onChange",
  });

  const selectedReason = watch("reasonList");
  const isOtherSelected = selectedReason?.value === "other";

  const onSubmit = (data: any) => {
    const id = sessionStorage.getItem("cameraId");
    if (!id) return closeCheckCameraModal();
    const message = data.reason ? data.reason : data.reasonList.label;
    handleAcceptCamera(id, message);
    closeCheckCameraModal();
  };

  return (
    <Modal
      title="Введите причину отклонения"
      withCloseBtn={false}
      isOpen={openModalReject === "rejected" ? true : false}
      actionClose={closeCheckCameraModal}
      customClassName={s.modalCameraCheck}
    >
      <form className={s.formStyle} onSubmit={handleSubmit(onSubmit)}>
        <div className={s.selectWrapper}>
          <Controller
            name={"reasonList"}
            control={control}
            render={({ onChange, value, onBlur }, { invalid }) => (
              <Select
                options={REASONS_OPTIONS}
                labelInValue
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                status={invalid ? "error" : ""}
                style={{ width: "100%" }}
              />
            )}
          />
          {isOtherSelected && (
            <TextArea
              placeholder="Введите причину"
              customClassName={s.textComment}
              control={control}
              name="reason"
            />
          )}
        </div>
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <Button
            htmlType="button"
            color="secondary"
            onClick={closeCheckCameraModal}
          >
            Отмена
          </Button>
          <Button htmlType="submit" disabled={!isValid} color="primary">
            Отправить
          </Button>
        </div>
      </form>
    </Modal>
  );
};
export default RejectedModal;
